module.exports = __webpack_public_path__ + "img/jigou_daimg.1c3bece8.png";